import { render, staticRenderFns } from "./Approve.vue?vue&type=template&id=18ada14f&scoped=true"
import script from "./Approve.vue?vue&type=script&lang=js"
export * from "./Approve.vue?vue&type=script&lang=js"
import style0 from "./Approve.vue?vue&type=style&index=0&id=18ada14f&prod&scoped=true&lang=css"
import style1 from "./Approve.vue?vue&type=style&index=1&id=18ada14f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18ada14f",
  null
  
)

export default component.exports